// export default function Footer({ go }) {
//   return (
//     <footer style={{ background:'var(--teal-deeper)', color:'rgba(255,255,255,.7)', padding:'3rem 2rem 1.5rem' }}>
//       <div className="container">
//         <div style={{ display:'grid', gridTemplateColumns:'1.5fr 1fr 1fr 1fr', gap:'2rem', marginBottom:'2.5rem', flexWrap:'wrap' }}>
//           {/* Brand */}
//           <div>
//             <div onClick={() => go('home')} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16, cursor:'pointer' }}>
//               <div style={{ width:36, height:36, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontFamily:"'DM Serif Display',serif", fontSize:16 }}>T</div>
//               <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:20, color:'white' }}>Tinytrust <span style={{ color:'var(--coral)' }}>Services</span></span>
//             </div>
//             <p style={{ fontSize:13, lineHeight:1.8, maxWidth:260, color:'rgba(255,255,255,.6)', marginBottom:16 }}>Calgary's trusted nanny placement agency. Every caregiver in our network is personally vetted by our founder — background check, CPR, references, and interview — before meeting your family.</p>
//             <div style={{ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)', borderRadius:8, padding:'8px 14px', display:'inline-flex', alignItems:'center', gap:8 }}>
//               <span style={{ fontSize:12 }}>🪪</span>
//               <span style={{ fontSize:12, color:'var(--teal-mid)', fontWeight:600 }}>Employment Agency Licence No: TN28080273</span>
//             </div>
//           </div>
//           {/* For Families */}
//           <div>
//             <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>For Families</div>
//             {[['home','How it works'],['nannies','Browse nannies'],['vetting','Our vetting process'],['pricing','Pricing'],['consult','Book a consult']].map(([p,l]) => (
//               <div key={l} onClick={() => go(p)} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:10, cursor:'pointer', transition:'color .2s' }}
//                 onMouseEnter={e=>e.target.style.color='white'} onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
//             ))}
//           </div>
//           {/* Services */}
//           <div>
//             <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Services</div>
//             {['Full-time nanny','After-school care','Special needs care','Overnight & weekend','Join as a caregiver'].map(l => (
//               <div key={l} onClick={() => go('consult')} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:10, cursor:'pointer', transition:'color .2s' }}
//                 onMouseEnter={e=>e.target.style.color='white'} onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
//             ))}
//           </div>
//           {/* Contact + Legal */}
//           <div>
//             <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Contact</div>
//             <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8 }}>📞 204-510-3869</div>
//             <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8 }}>📧 info@tinytrustservices.ca</div>
//             <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:24 }}>📍 Calgary, Alberta</div>
//             <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Legal</div>
//             {[['privacy','Privacy policy'],['terms','Terms & conditions'],['terms','Disclaimer']].map(([p,l]) => (
//               <div key={l} onClick={() => go(p)} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8, cursor:'pointer', transition:'color .2s' }}
//                 onMouseEnter={e=>e.target.style.color='white'} onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
//             ))}
//           </div>
//         </div>

//         <div style={{ borderTop:'1px solid rgba(255,255,255,.1)', paddingTop:'1.5rem', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
//           <span style={{ fontSize:13 }}>© 2025 Tinytrust Services · Calgary, Alberta, Canada</span>
//           <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
//             {['Alberta PIPA Compliant','VSC Verified Agency','Licensed Employment Agency','Alberta Employment Standards'].map(b => (
//               <span key={b} style={{ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.12)', borderRadius:20, padding:'4px 12px', fontSize:11, fontWeight:600, color:'rgba(255,255,255,.5)' }}>{b}</span>
//             ))}
//           </div>
//         </div>

//         {/* Hidden admin link — only visible if you know it's there */}
//        {/* Hidden admin link */}
// <div style={{ textAlign:'center', paddingTop:16 }}>
//   <span
//     onClick={() => go('admin')}
//     style={{ fontSize:11, color:'rgba(255,255,255,.2)', cursor:'pointer', userSelect:'none' }}
//   >
//     Admin
//   </span>
// </div>
//       </div>
//     </footer>
//   );
// }
export default function Footer({ go }) {
  return (
    <footer style={{ background:'var(--teal-deeper)', color:'rgba(255,255,255,.7)', padding:'3rem 1.5rem 1.5rem' }}>
      <style>{`
        .footer-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr;
          gap: 2rem;
          margin-bottom: 2.5rem;
        }
        .footer-badges {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }
        .footer-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 12px;
        }
        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 1.5rem;
          }
        }
        @media (max-width: 480px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
          .footer-bottom {
            flex-direction: column;
            text-align: center;
          }
          .footer-badges {
            justify-content: center;
          }
        }
      `}</style>

      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div>
            <div onClick={() => go('home')} style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16, cursor:'pointer' }}>
              <div style={{ width:36, height:36, borderRadius:'50%', background:'var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontFamily:"'DM Serif Display',serif", fontSize:16, flexShrink:0 }}>T</div>
              <span style={{ fontFamily:"'DM Serif Display',serif", fontSize:20, color:'white' }}>Tinytrust <span style={{ color:'var(--coral)' }}>Services</span></span>
            </div>
            <p style={{ fontSize:13, lineHeight:1.8, color:'rgba(255,255,255,.6)', marginBottom:16 }}>Calgary's trusted nanny placement agency. Every caregiver is personally vetted by our founder — background check, CPR, references, and interview — before meeting your family.</p>
            <div style={{ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)', borderRadius:8, padding:'8px 14px', display:'inline-flex', alignItems:'center', gap:8 }}>
              <span style={{ fontSize:12 }}>🪪</span>
              <span style={{ fontSize:12, color:'var(--teal-mid)', fontWeight:600 }}>Licence No: TN28080273</span>
            </div>
          </div>

          {/* For Families */}
          <div>
            <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>For Families</div>
            {[['home','How it works'],['nannies','Browse nannies'],['vetting','Our vetting'],['pricing','Pricing'],['consult','Book a consult']].map(([p,l]) => (
              <div key={l} onClick={() => go(p)} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:10, cursor:'pointer' }}
                onMouseEnter={e=>e.target.style.color='white'}
                onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
            ))}
          </div>

          {/* Services */}
          <div>
            <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Services</div>
            {['Full-time nanny','After-school care','Special needs care','Overnight & weekend','Join as a caregiver'].map(l => (
              <div key={l} onClick={() => go('consult')} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:10, cursor:'pointer' }}
                onMouseEnter={e=>e.target.style.color='white'}
                onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
            ))}
          </div>

          {/* Contact + Legal */}
          <div>
            <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Contact</div>
            <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8 }}>📞 204-510-3869</div>
            <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8 }}>📧 info@tinytrustservices.ca</div>
            <div style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:24 }}>📍 Calgary, Alberta</div>
            <div style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.5)', textTransform:'uppercase', marginBottom:16 }}>Legal</div>
            {[['privacy','Privacy policy'],['terms','Terms & conditions'],['terms','Disclaimer']].map(([p,l]) => (
              <div key={l} onClick={() => go(p)} style={{ fontSize:14, color:'rgba(255,255,255,.6)', marginBottom:8, cursor:'pointer' }}
                onMouseEnter={e=>e.target.style.color='white'}
                onMouseLeave={e=>e.target.style.color='rgba(255,255,255,.6)'}>{l}</div>
            ))}
          </div>
        </div>

        <div style={{ borderTop:'1px solid rgba(255,255,255,.1)', paddingTop:'1.5rem' }}>
          <div className="footer-bottom">
            <span style={{ fontSize:13 }}>© 2025 Tinytrust Services · Calgary, Alberta, Canada</span>
            <div className="footer-badges">
              {['Alberta PIPA Compliant','VSC Verified Agency','Licensed Employment Agency','Alberta Employment Standards'].map(b => (
                <span key={b} style={{ background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.12)', borderRadius:20, padding:'4px 12px', fontSize:11, fontWeight:600, color:'rgba(255,255,255,.5)' }}>{b}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Hidden admin link */}
        <div style={{ textAlign:'center', paddingTop:16 }}>
          <span onClick={() => go('admin')} style={{ fontSize:11, color:'rgba(255,255,255,.2)', cursor:'pointer', userSelect:'none' }}>Admin</span>
        </div>
      </div>
    </footer>
  );
}